import React, {FC} from "react"

import Spacing from "@irati/ui/src/Spacing"
import {Card} from "@irati/ui/src/Layout"
import {H1, Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"

interface Props {}

const PayrollPayLandingScreen: FC<Props> = () => {
  const schemeType = window.location.pathname.split("/")[1]
  // get url root and send it as schemeType payload to GraphQL query
  return (
    <Spacing margin={4}>
      <Card>
        <H1>
          <FormattedMessage id="payrollPayStore.landing.title"/>
        </H1>
        <Body margin={[2, 0, 1]}>
          Scheme type:
        </Body>
        <pre>{schemeType}</pre>
      </Card>
    </Spacing>
  )
}

export default PayrollPayLandingScreen
